import Vue from 'vue';
Vue.filter('usertype', function(usertype) {
    var type='';
    switch(usertype){
        case 'construction':
        type='工队'
        break;
        case 'sysuser':
        type='勘察'
        break;
        case 'customer':
        type='客户'
        break;
        default:
        type=''
    }
    return type
  });

Vue.filter("getDatetime", function (time) {
  if(time){
    if(time.toString().indexOf('-')>-1){
      time = time.replace(/-/g,'/');
    }
  }
  var _Date = new Date(time);
  var y = _Date.getFullYear();
  var m = _Date.getMonth()+1;
  var d = _Date.getDate();
  var hours = _Date.getHours();
  var minutes = _Date.getMinutes();
  var seconds = _Date.getSeconds();
  return y +'-'+
    (m <10 ? '0'+m : m) +'-'+
    (d <10 ? '0'+d : d) +' '+
    (hours <10 ? '0'+hours : hours)+':'+
    (minutes <10 ? '0'+minutes : minutes)+':'+
    (seconds <10 ? '0'+seconds : seconds);
});

// 日期转2018年12月6日
Vue.filter("getYmd", function (time) {
  var y=new Date(time).getFullYear();
  var m=new Date(time).getMonth()+1;
  var d=new Date(time).getDate();
  return y+'年'+m+'月'+d+'日'
});

// 工程状态
Vue.filter("filter_servicestate", function (state) {
  var text;
  state = String(state);
  switch(state){
    case "-3":
      text = "上门未成交";
      break;
    case "-2":
      text = "不需要上门";
      break;
    case "0":
      text = "未开工";
      break;
    case "1":
      text = "进行中";
      break;
    case "2":
      text = "已完成";
      break;
    default:
      text = "未开工";
  }
  return text;
});

// 工程状态
Vue.filter("filter_procedureType", function (text) {
  if(!text)false;
  if(text.indexOf("_")>-1){
    text = text.split("_")[0];
  }
  return text;
});



// WEBPACK FOOTER //
// ./src/filter/filters.js